export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/ad997ce8fd38a906d34bbafa619345f7e390209051cda6b62cecf00f993168e7.jpeg";

export const STORY_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/43243a39660fa010cb99ccbc1875f362a0178f1eb0df12bfebe07628a445c848.jpeg";

export const CARD_SPONSOR =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/52dffac85f92f79f7de2516d2e2ad21b81142511e598e7130e53b950be482e0d.jpeg";

export const CARD_STORY =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/aea38d0eb0acf950017489c840824b9c5fb4272d34b2d3f29fdfd042b6ba32f7.jpeg";

export const TEXTURE_SILK =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/479d9835544ecb64b11c9528c27d79b6d17c9c3fe5cf5c8c2450137d67c5b168.jpeg";

export const PILLAR_RETE =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/064f469892e6cea1ba30cefab7f310671a3bdf23f06727d6349e3f5fdc5356eb.jpeg";

export const PILLAR_VISIBILITA =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/fc8a781a69923ee3559c0a10cb50b8a82885bdf4403e2321e781dc52fbb94b8e.jpeg";

export const PILLAR_SOSTEGNO =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/aa0608fd31da77322c8d60fe1fd4562e3eb3ab62c3cb059b2007666b33cb5699.jpeg";

export const PILLAR_INNOVAZIONE =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/b2179f62d921357d07ce68d392b67a25a362c1fab6e2984b667f864f6e282022.jpeg";

export const ASSISTANT_ROBOT =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/632d5fb1dd4ae4230a8127188732c6513bc4a6c182c09b30e9d1060be56fcbb8.jpeg";

export const COMMUNITY_TABLE =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/2a61295d4e3971c39132282c1a1c18063d2ccd3a3c0155cebbddee3b4488b09e.jpeg";

export const MENTORSHIP_PAIR =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/94881d53b773af67d1107d736bbbe78540df7712ae6a68c16abf285bc40c3edb.jpeg";

export const ENTREPRENEUR_WORKSHOP =
  "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/23df58154d6e9190a06ce1faa259209d6cb2ea8a67d3fcffd00e6a6af0a93da3.jpeg";
